import React from 'react';
import { Label, Input } from 'reactstrap';

export const NextUtilitySelector = ({
    availableUtilities,
    selectedUtility,
    onChange,
    disabled = false,
    label = 'Дополнительная обработка (опционально)',
}) => {
    if (availableUtilities.length <= 1) return null;

    return (
        <div>
            <Label for="utilitySelect" className="form-label standard-text mr-2">
                {label}
            </Label>
            <Input
                type="select"
                name="utility"
                id="utilitySelect"
                value={selectedUtility === null ? 'null' : selectedUtility}
                onChange={onChange}
                disabled={disabled}
                className="standard-bg standard-text standard-select"
            >
                {availableUtilities.map((option) => (
                    <option
                        key={option.value || 'none'}
                        value={option.value === null ? 'null' : option.value}
                    >
                        {option.label}
                    </option>
                ))}
            </Input>
        </div>
    );
};